(function () {
    "use strict";

    var ResizableReportPanel = Solovis.defineClass(
        "Solovis.Reports.Parts.CustomPanels.ResizableReportPanel",
        null,
        function (options) {
            var self = this;

            this.parentReportControl = options.parentReportControl;
            this.customPanelsControl = options.customPanelsControl;

            this.panelSetDiv = options.panelSetDiv;

            var initialLeft;
            var initialTop;
            var initialWidth;
            var initialHeight;
            var initialZIndex;

            if (options.panelState) {
                var panelState = options.panelState;

                this.reportCode = panelState.reportCode;
                this.initialParametersToUse = panelState.parameters ? panelState.parameters : null;
                this.initialPersistedSettingsToUse = panelState.persistedSettings ? panelState.persistedSettings : null;
                this._parameterMappings = panelState.parameterMappings ? panelState.parameterMappings : null;;

                initialLeft = panelState.left;
                initialTop = panelState.top;
                initialWidth = panelState.width;
                initialHeight = panelState.height;
                initialZIndex = panelState.zIndex ? panelState.zIndex : null;
            }
            else {
                this.reportCode = options.reportCode ? options.reportCode : null;
                this.initialParametersToUse = options.parameters ? options.parameters : null;
                this.initialPersistedSettingsToUse = options.defaultPersistedSettings ? options.defaultPersistedSettings : null;
                this._parameterMappings = null;

                initialLeft = options.initialLeft ? options.initialLeft : 0;
                initialTop = options.initialTop ? options.initialTop : 0;
                initialWidth = options.initialWidth ? options.initialWidth : 500;
                initialHeight = options.initialHeight ? options.initialHeight : 300;
            }

            this.resizableContainer = $("<div>")
                .addClass("report-block-with-header-layout")
                .addClass("resizable-report-panel")
                .css("position", "absolute")
                .css("left", initialLeft)
                .css("top", initialTop)
                .css("margin-top", 0)
                .width(initialWidth)
                .height(initialHeight)
                .appendTo(this.panelSetDiv);

            if (initialZIndex) {
                this.resizableContainer.css("z-index", initialZIndex);
            }

            this.header = $("<div>")
                .addClass("report-block-header")
                .addClass("resizable-panel-drag-handle")
                .css("cursor", "pointer")
                .appendTo(this.resizableContainer);

            this._headerContent = $("<div>")
                .addClass("report-block-header-content")
                .appendTo(this.header);

            this._headerActions = $("<div class='float-right'>").appendTo(this._headerContent);
           
            var reportOptionsButtonLink = $("<a>").html('<span class="fa fa-gear"></span>').appendTo(this._headerActions);
            reportOptionsButtonLink.css("margin-right", "5px");
            Solovis.UI.PopupLinkPanel.onElementClick(
                reportOptionsButtonLink,
                function (e) {
                    if (self.reportControl) {
                        self.reportControl.showReportOptionsMenu({
                            optionsElement: reportOptionsButtonLink
                        });
                    }
                });

            var panelSettingsLink = $("<a>").html('<span class="fa fa-bars"></span>').appendTo(this._headerActions);
            panelSettingsLink.css("margin-right", "5px");
            panelSettingsLink.click(function () { self._showPanelSettingsMenu(panelSettingsLink); });

            var removePanelLink = $("<a>").html('<span class="fa fa-times"></span>').appendTo(this._headerActions);
            removePanelLink.css("margin-right", "5px");
            removePanelLink.click(function () { self.destroy(); });            

            this.headerTitle = $("<h3>").text("Panel").appendTo(this._headerContent);
       
            this.content = $("<div>")
                .addClass("report-block-content")
                .css("padding", "0")
                .css("border", "1px solid #ecf0f1")
                .css("border-top", "none")
                .css("overflow", "auto")
                .css("box-sizing", "border-box")                
                .appendTo(this.resizableContainer);

            this._fixupContentWidthAndHeight(initialWidth, initialHeight);


            ($(this.resizableContainer) as any).draggable({
                handle: ".resizable-panel-drag-handle",
                stack: ".resizable-report-panel",
                distance: 10,
                           
                drag: function (event, ui) {                    
                    // Don't let items go off left or top, but allow canvas to grow to right and down.
                    if (ui.position) {
                        if (ui.position.left < 0) {
                            ui.position.left = 0;
                        }
                        if (ui.position.top < 0) {
                            ui.position.top = 0;
                        }
                    }
                }
            });

            ($(this.resizableContainer) as any).resizable({
                handles: "n, w, e, se, s",
                minWidth: 200,
                minHeight: 80,

                resize: function (event, ui) {
                    var currentWidth = ui.size.width;
                    var currentHeight = ui.size.height;

                    // Resize immediately to avoid delayed resize.
                    $(this).width(currentWidth);
                    $(this).height(currentHeight);

                    self._fixupContentWidthAndHeightForCurrentPanelSize();
                }
            });

            // Hide the resize grip.
            $(".ui-icon-gripsmall-diagonal-se", this.resizableContainer).css("background-image", 'url("")')

            this._createReportControl();
        });

    ResizableReportPanel.prototype._fixupContentWidthAndHeightForCurrentPanelSize = function () {
        var currentWidth = $(this.resizableContainer).width();
        var currentHeight = $(this.resizableContainer).height();       

        this._fixupContentWidthAndHeight(currentWidth, currentHeight);
    };

    ResizableReportPanel.prototype._fixupContentWidthAndHeight = function (currentWidth, currentHeight) {
        var headerHeight = this.header.outerHeight();
       
        var contentHeight = currentHeight - headerHeight;

        this.content.css("width", currentWidth + "px");
        this.content.css("height", contentHeight + "px");

        var contentInnerWidth = this.content.width();
        var contentInnerHeight = this.content.height();
  
        if (this.reportControl) {
            this.reportControl.setSpaceAvailable(contentInnerWidth, contentInnerHeight);
        }
    };

    ResizableReportPanel.prototype._createReportControl = function () {
        var self = this;

        if (this.reportCode) {
            var reportHostDiv = $("<div>").appendTo(this.content);

            this.reportControl = new Solovis.Reports.ReportControl({
                controlHost: reportHostDiv,

                parentReportControl: this.parentReportControl,

                autoRun: true,
                reportCode: this.reportCode,
                parameters: this.initialParametersToUse,
                persistedSettings: this.initialPersistedSettingsToUse,

                hideReportOptionsButton: true,                
            });
            this.reportControl.setAsCurrentControl();

            $(this.reportControl).bind("reportDataLoaded", function () {
                self._updatePanelTitle();
            });

            $(this.reportControl).bind("renderComplete", function () {
                // At this point, report definition will be loaded, so we should be able to see if we need to allow overflow.
                // On reports that use "autoSizeSpaceAvailable", we will allow overflows to be visible by default since it will likely
                // be a tooltip on a chart or something like that.
                if (self.reportControl && self.reportControl.report) {
                    if (self.reportControl.report.autoSizeSpaceAvailable) {
                        self.content.css("overflow", "visible");
                    }
                }
            });

            $(this.reportControl).bind("parameterLabelOnParameterLabelDrop", function (e, data) {
                self._handleParameterLabelOnParameterLabelDrop(data);
            } as any);

            this._fixupContentWidthAndHeightForCurrentPanelSize();
        }
    };

    ResizableReportPanel.prototype._updatePanelTitle = function () {
        var title = this.reportControl.getReportTitle();

        if (title) {
            this.headerTitle.text(title);
        }
    };

    ResizableReportPanel.prototype.getPersistedState = function () {
        var state: any = {
            reportCode: this.reportCode ? this.reportCode : null,
            parameterMappings: this._parameterMappings
        };

        if (this.reportControl) {
            state.parameters = this.reportControl.getSerializedParameterValues();
            state.persistedSettings = this.reportControl.collectPersistedSettings();
        }

        state.left = this.resizableContainer.css("left");
        state.top = this.resizableContainer.css("top");
        state.width = this.resizableContainer.width();
        state.height = this.resizableContainer.height();
        state.zIndex = this.resizableContainer.css("z-index");

        return state;
    };

    ResizableReportPanel.prototype.destroy = function () {
        if (this.resizableContainer) {
            this.resizableContainer.remove();
            this.resizableContainer = null;

            // Make sure we removed reference in custom panels control.
            this.customPanelsControl.removePanel(this);
        }
    };


    ResizableReportPanel.prototype.applyParameterValues = function (parameters, valuesChanged) {
        var newParamValues = {};
        
        var currentParamValues = {};
        if (this.reportControl) {
            currentParamValues = this.reportControl.getParameterValues();
        }

        var changeCount = Solovis.Reports.ReportStackEngine.applyParameterMappings(this._parameterMappings, parameters, newParamValues, currentParamValues);

        if (changeCount > 0 && this.reportControl) {
            this.reportControl.setParameterValues(newParamValues);
            // TODO: Make it so that running the report doesn't happen until after parameters are fully loaded.
            this.reportControl.runReport();
        }        
    };


    ResizableReportPanel.prototype.showParameterMappingsEditor = function () {
        var self = this;

        (Solovis.Reports as any).ReportStacks.ReportParameterMappingListEditorControl.showDialog(
            {
                parameterMappings: self._parameterMappings,

                topLevelParameters: function () {
                    return self.customPanelsControl._parameters;
                },

                reportDefinition: self.reportControl.report                
            },
            function (updatedParameterMappings) {
                self._parameterMappings = updatedParameterMappings;                
            });
    };    


    ResizableReportPanel.prototype._showPanelSettingsMenu = function (offsetElement) {
        var self = this;

        offsetElement.addClass("active");

        var linkPanel = Solovis.UI.PopupLinkPanel.showLinks({
            offsetElement: offsetElement,
            offsetRight: true,
            offsetBottom: true,
            fromRightEdge: true,
            links: [
                {
                    label: "Edit Parameter Mappings",
                    click: function () {
                        self.showParameterMappingsEditor();
                    }
                }
            ],

            close: function () {
                offsetElement.removeClass("active");
            }
        });
    };


    ResizableReportPanel.prototype.bringToFront = function () {
        var self = this;

        var maxZIndex = 0;
        $(this.customPanelsControl._panelList).each(function (i, panel: any) {
            if (panel !== self) {
                var zIndex = parseInt(panel.resizableContainer.css("z-index"));
                if (maxZIndex < zIndex) {
                    maxZIndex = zIndex;
                }
            }
        });

        this.resizableContainer.css("z-index", maxZIndex + 1);
    };

    ResizableReportPanel.prototype._handleParameterLabelOnParameterLabelDrop = function (data) {
        // We will try to create a parameter mapping if someone drops a report parameter from the top-level report.
        var self = this;

        var result = (Solovis.Reports as any).ReportStacks.ReportParameterMappingListEditorControl.addParameterMappingFromParameterLabelOnParameterLabelDrop(
            {
                parameterMappings: self._parameterMappings,

                topLevelParameters: function () {
                    return self.customPanelsControl._parameters;
                },

                reportDefinition: self.reportControl.report,

                paramDropData: data
            });

        var newMapping = result.newMapping;
        this._parameterMappings = result.newParameterMappings;

        var message;
        if (result.newMapping) {
            message = "Mapped '" + data.droppedParamRef.label + "' to '" + data.targetParamInfo.label + "'.";
            Solovis.Site.AlertManager.alert({ text: message });
        }
        else {
            message = "Unable to create parameter mapping.";
            Solovis.Site.AlertManager.alert({ text: message });
        }
    };

})();